module.exports = __webpack_public_path__ + "static/media/users-icon.50aae4c8.svg";